import { useState } from 'react';

import { EditSireDialog } from '@/components/common/edit-sire-dialog';
import { Sire } from '@/rtk-query.gql';
import { SemenDto } from '@/services/semen-service';

export const SireLink = ({
  sire,
  onSaved,
}: {
  sire: SemenDto['sire'];
  onSaved?: () => void;
}) => {
  const [editSireDialogVisible, setEditSireDialogVisible] = useState(false);

  return (
    <>
      <span 
        role="button"
        tabIndex={0}
        onClick={() => setEditSireDialogVisible(true)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setEditSireDialogVisible(true);
          }
        }}
        className="cursor-pointer truncate text-blue-600 hover:underline"
      >
        {sire.name}
      </span>
      {editSireDialogVisible && (
        <EditSireDialog
          visible={editSireDialogVisible}
          onHide={() => setEditSireDialogVisible(false)}
          onSave={() => {
            setEditSireDialogVisible(false);
            onSaved?.();
          }}
          sire={sire as unknown as Sire}
        />
      )}
    </>
  );
};
